module.exports = __webpack_public_path__ + "c557a83b387c3f232a20a1d9af19be37.svg";